import React from 'react';
import { withRouter } from 'react-router-dom';
import { Row, Col, Divider, Alert } from 'antd';
import { Form, Input, Button, FooterToolbar, Page, ContentWrapper, Loading } from '~/components';
import { PrincipalService, UserService } from '~/services';
import { notifySuccess, generateUuid } from '~/utils';
import './AlterarSenhaPage.less';
import { focusField } from '~/utils/functions';

class AlterarSenhaPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoadingContato: false,
      dataItemsContato: [],
    };
  }

  componentDidMount() {
    focusField(this.editInput);

    this.buscarContato('RELATORIO');
  }

  buscarContato = arquivo => {
    this.setState({ isLoadingContato: true }, () => {
      PrincipalService.getAllContato(
        arquivo,
        dataItemsContato => this.setState({ dataItemsContato, isLoadingContato: false }),
        () => this.setState({ dataItemsContato: [], isLoadingContato: false })
      );
    });
  };

  handleSave = values => {
    this.setState({ isLoading: true });

    UserService.alterarSenha(values, this.onSave, this.onSave);
  };

  onSave = (error = false) => {
    this.setState({ isLoading: false });

    if (!error) {
      const { name } = this.props;
      const action = {
        perfectPast: ' realizado com sucesso',
      };
      notifySuccess({ action, name });
      this.saveApi.reset();

      const { history } = this.props;
      UserService.logout(() => history.push(`/login`));
    }
  };

  renderErroSenha = (senhaErro, senhaTexto) => {
    if (senhaErro) {
      return (
        <>
          <Divider style={{ marginTop: 15 }}>Erros</Divider>
          <Alert
            message="Senha inválida"
            description={
              <ul style={{ marginBottom: 0 }}>
                {senhaTexto.map(item => (
                  <li key={generateUuid()}>{item}</li>
                ))}
              </ul>
            }
            type="error"
            showIcon
          />
        </>
      );
    }
    return null;
  };

  render() {
    const { tabId } = this.props;
    const { isLoading, isLoadingContato, dataItemsContato } = this.state;
    const values = this.saveApi ? this.saveApi.getValues() : {};
    let senhaErro = false;
    const senhaTexto = [];
    if (values && values.nova_senha) {
      if (!/[0-9]/g.test(values.nova_senha)) {
        senhaTexto.push('A senha deve conter ao menos um número.');
      }
      if (!/[A-Za-z]/g.test(values.nova_senha)) {
        senhaTexto.push('A senha deve conter ao menos uma letra.');
      }
      if (values.nova_senha.length < 8) {
        senhaTexto.push('A senha deve conter ao menos 8 caracteres.');
      }
      if (senhaTexto.length >= 1) {
        senhaErro = true;
      }
    }

    return (
      <>
        <div className="conteudo-box alterar-senha">
          <div className="form borda">
            <Page tabId={tabId}>
              <Form getApi={api => (this.saveApi = api)} onSubmit={this.handleSave}>
                <ContentWrapper>
                  <Row gutter={4}>
                    <Col md={8} span={24}>
                      <Input.Password
                        label="Senha Atual"
                        field="senha_atual"
                        disabled={isLoading}
                        required
                        forwardedRef={ref => (this.editInput = ref)}
                        capsLock={false}
                      />
                    </Col>
                    <Col md={8} span={24}>
                      <Input.Password
                        label="Nova Senha"
                        field="nova_senha"
                        disabled={isLoading}
                        required
                        capsLock={false}
                        onChange={() => this.forceUpdate()}
                      />
                    </Col>
                    <Col md={8} span={24}>
                      <Input.Password label="Confirmar Senha" field="confirmar_senha" disabled={isLoading} required capsLock={false} />
                    </Col>
                  </Row>
                  {this.renderErroSenha(senhaErro, senhaTexto)}
                </ContentWrapper>
              </Form>
            </Page>
            <FooterToolbar
              right={
                <>
                  <Button.Save
                    disabled={isLoading || senhaErro}
                    disabledReason={senhaErro && 'Senha inválida.'}
                    loading={isLoading}
                    onClick={() => this.saveApi.submitForm()}
                  />
                </>
              }
            />
          </div>

          <div className="painel-box">
            <div className="painel">
              <div className="aviso">
                <div className="titulo">Alterar Senha</div>
                <div className="texto">Mantenha uma senha atualizada e segura.</div>
                <div className="texto">A senha de conter:</div>
                <div className="texto">
                  <ul>
                    <li>- Ao menos 1 letra;</li>
                    <li>- Ao menos 1 número;</li>
                    <li>- No mínimo 8 caracteres;</li>
                  </ul>
                </div>
              </div>

              <div className="contato">
                <div>Dúvidas entre em contato com o setor responsável:</div>
                {isLoadingContato ? (
                  <Loading />
                ) : (
                  dataItemsContato.map(item => (
                    <div className="destaque">
                      <a href={`https://api.whatsapp.com/send?phone=55${item.zap}`} target="_blank" rel="noopener noreferrer nofollow">
                        {`${item.telefone} ${item.nome}`}
                      </a>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(AlterarSenhaPage);
